import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import AffSection1 from "@/pages/affiliate/AffiliateComponents/AffSection1/AffSection1";
import AffSection2 from "@/pages/affiliate/AffiliateComponents/AffSection2/AffSection2";
import AffSection3 from "@/pages/affiliate/AffiliateComponents/AffSection3/AffSection3";
import AffSection4 from "@/pages/affiliate/AffiliateComponents/AffSection4/AffSection4";
import AffSection5 from "@/pages/affiliate/AffiliateComponents/AffSection5/AffSection5";
var Affiliate = function Affiliate() {
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    linksForSearch: true
  }, /*#__PURE__*/React.createElement(AffSection1, null), /*#__PURE__*/React.createElement(AffSection2, null), /*#__PURE__*/React.createElement(AffSection3, null), /*#__PURE__*/React.createElement(AffSection4, null), /*#__PURE__*/React.createElement(AffSection5, null));
};
export default Affiliate;